import { IconButton } from 'components/Blocks';
import { useAppWrapper } from '../WrapperContext';
import { MenuIcon } from 'components/Icons';

export function HeaderSideBarButton() {
  const { showMobileSidebar, toggleSideBar } = useAppWrapper();

  if (!showMobileSidebar) return null;

  return (
    <IconButton onClick={toggleSideBar}>
      <MenuIcon />
    </IconButton>
  );
}
